/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
export default {
  getContractData: function (id) {
 
    return axios.post("/api/" + id).then(result => result.data);
  },
  postPayment: function (req) {
    return axios.post("/api/" + req.id + "/payment", req).then(result => result.data);
  },
  postContract: function (req) {
    return axios.post("/api/" + req.id + "/sign", req).then(result => result.data);
  },
  getSendEmail: function (req) {
    let { recordID, BookingContactEmail, __PK_BEO_ID, emailHash } = req;
    return axios
      .post(`/api/${emailHash}/sendemail`, { recordID, BookingContactEmail, __PK_BEO_ID })
      .then(result => result.data);
  }
};